export default "__VITE_ASSET__Bt9PvTc4__"